import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ShirtIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M16 21.8H8c-.7 0-1.3-.3-1.8-.8s-.8-1.1-.8-1.8V12c-.2.1-.4.2-.6.2-.3 0-.5-.1-.7-.3L.9 8.7c-.4-.4-.4-1 0-1.4L5.3 3c.5-.5 1.1-.8 1.8-.8h9.8c.7 0 1.4.3 1.8.8L23 7.3c.2.2.3.4.3.7 0 .3-.1.5-.3.7l-3.2 3.2c-.2.2-.4.3-.7.3-.2 0-.4-.1-.6-.2v7.2c0 .7-.3 1.4-.8 1.8-.4.5-1 .8-1.7.8zM6.4 8.6c.1 0 .3 0 .4.1.4.2.6.5.6.9v9.6c0 .2.1.3.2.4.1.1.3.2.4.2h8c.2 0 .3-.1.4-.2.1-.1.2-.3.2-.4V9.6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l.9.9L20.9 8l-3.6-3.6c-.1-.1-.3-.2-.4-.2H7.1c-.2 0-.3.1-.4.2L3.1 8l1.8 1.8.9-.9c.1-.2.4-.3.6-.3z"
                    })
                })
            })
        ]
    });
};
ShirtIcon.isCarinaIcon = true;
export default ShirtIcon;
